import { EXERCISE_MULTIPLE_CHOICE_OPTIONS } from '../types';

export const getNodeIndexFromChild = (nodeList, childElementId) => {
  return nodeList
    ?.findIndex((eachNode) =>
      eachNode.children.some((eachChild) => eachChild.id === childElementId));
};

export const getNodeFromChild = (nodeList, childElementId) => {
  return nodeList
    ?.find((eachNode) =>
      eachNode.children.some((eachChild) => eachChild.id === childElementId));
};

export const getQuestionOptions = (questionNode) => {
  return questionNode?.children
    ?.find((ele) => ele?.type === EXERCISE_MULTIPLE_CHOICE_OPTIONS)
    ?.children
    ?.map((eachOption, optionIndex) => ({
      ...eachOption,
      optionIndex
    }));
};
